import React from 'react';
import {FormControl, InputLabel, MenuItem, Select, TextField} from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import {DatePicker} from '@mui/x-date-pickers';
import useUser from '../../../../../utility/hooks/useUser';
import {ROLES} from '../../../../../constants/roles';

const BasicInfoFields = ({fields, profileData, isEditMode, handleChangeValue, errors, selectOptions}) => {
    const {user} = useUser();

    return (
        fields.map((field, index) => {
                if (field.type === 'textField') {
                    return <TextField
                        fullWidth
                        key={`textField_${field.key}`}
                        label={field.title}
                        value={profileData[field.key]}
                        helperText={errors[field.key] ? errors[field.key] : ''}
                        error={!!errors[field.key]}
                        autoComplete='off'
                        disabled={!isEditMode || (!field.parentEdit && user.role === ROLES.PARENT)}
                        onChange={event => handleChangeValue(event.target.value, field)}/>
                } else if (field.type === 'datePicker') {
                    return <DatePicker
                        key={`datePicker_${field.key}`}
                        variant={'fulfilled'}
                        label={field.title}
                        value={profileData[field.key] ? moment(profileData[field.key]) : null}
                        onChange={newValue => {
                            let date = new Date(newValue.year(), newValue.month(), newValue.date());
                            handleChangeValue(date, field)
                        }}
                        sx={{width: '100%', my: 0}}
                        maxDate={moment(new Date())}
                        disabled={!isEditMode || (!field.parentEdit && user.role === ROLES.PARENT)}
                        required={false}
                        format={'D-MMM-YYYY'}
                        minDate={moment(field.minDate)}
                        slotProps={{
                            field: {
                                readOnly: true
                            }
                        }}
                    />
                } else if (field.type === 'select') {
                    return <FormControl key={`select_${field.key}_${profileData[field.key]}`}
                                        disabled={!isEditMode || (!field.parentEdit && user.role === ROLES.PARENT)}>
                        <InputLabel>{field.title}</InputLabel>
                        <Select
                            value={profileData[field.key] || ''}
                            label={field.title}
                            onChange={event => handleChangeValue(event.target.value, field)}
                        >
                            {!field.isRequired && <MenuItem key={`select_${index}`} value={null}>&nbsp;</MenuItem>}
                            {
                                selectOptions[field.key]?.map(({value, title}) => (
                                    <MenuItem key={value} value={value}>{title}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                } else {
                    return null
                }
            }
        )

    );
};

BasicInfoFields.propTypes = {
    fields: PropTypes.array.isRequired,
    profileData: PropTypes.object.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    handleChangeValue: PropTypes.func.isRequired,
    flex: PropTypes.number,
    errors: PropTypes.object,
    selectOptions: PropTypes.object,
};
export default BasicInfoFields;